const API_URL = process.env.REACT_APP_API_URL || '';

function toFormData(data) {
  if (!data) return '';
  return Object.entries(data).map(([k, v]) =>
    encodeURIComponent(k) + '=' + encodeURIComponent(typeof v === 'object' ? JSON.stringify(v) : String(v))
  ).join('&');
}

async function req(method, path, data) {
  const opts = { method, headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, credentials: 'include' };
  if (data) opts.body = toFormData(data);
  const res = await fetch(`${API_URL}/backend/${path}`, opts);
  const json = await res.json();
  if (!res.ok) throw new Error(json.error || 'Error');
  return json;
}

const FIELD_MAP = {
  equipoId: 'equipo_id',
  ticketId: 'ticket_id',
  fotoRemito: 'remito_foto',
  created_at: 'created_at',
};
const REVERSE_MAP = Object.fromEntries(Object.entries(FIELD_MAP).map(([k, v]) => [v, k]));

function mapFields(obj, reverse = false) {
  if (!obj || typeof obj !== 'object') return obj;
  const map = reverse ? REVERSE_MAP : FIELD_MAP;
  const mapped = {};
  for (const [k, v] of Object.entries(obj)) {
    mapped[map[k] || k] = v;
  }
  return mapped;
}

// ============================
// EQUIPOS
// ============================
export async function fetchEquipos() {
  const res = await req('GET', 'equipos.php');
  return (res.data || res || []).map(i => mapFields(i, true));
}
export async function createEquipo(data) {
  const res = await req('POST', 'equipos.php', mapFields(data));
  return mapFields(res, true);
}
export async function updateEquipo(data) {
  const res = await req('PUT', 'equipos.php', mapFields(data));
  return mapFields(res, true);
}
export async function deleteEquipo(id) {
  return await req('DELETE', `equipos.php?id=${id}`);
}

// ============================
// TICKETS
// ============================
export async function fetchTickets() {
  const res = await req('GET', 'tickets.php');
  return (res.data || res || []).map(i => mapFields(i, true));
}
export async function createTicket(data) {
  const res = await req('POST', 'tickets.php', mapFields(data));
  return mapFields(res, true);
}
export async function updateTicket(data) {
  await req('PUT', 'tickets.php', mapFields(data));
}
export async function deleteTicket(id) {
  return await req('DELETE', `tickets.php?id=${id}`);
}
export async function avanzarTicket(id, nuevoEstado, equipoId) {
  return await req('PUT', 'tickets.php', { avanzar: 1, id, estado: nuevoEstado, equipo_id: equipoId });
}
export async function retrocederTicket(id, equipoId) {
  return await req('PUT', 'tickets.php', { retroceder: 1, id, equipo_id: equipoId });
}
export async function reingresarEquipo(equipoId, data) {
  return await req('POST', 'equipos.php', { action: 'reingreso', id: equipoId, ...mapFields(data) });
}

// ============================
// DIAGNÓSTICOS
// ============================
export async function fetchDiagnosticos() {
  const res = await req('GET', 'diagnosticos.php');
  return (res.data || res || []).map(i => mapFields(i, true));
}
export async function createDiagnostico(data) {
  const res = await req('POST', 'diagnosticos.php', mapFields(data));
  return mapFields(res, true);
}
export async function updateDiagnostico(data) {
  await req('PUT', 'diagnosticos.php', mapFields(data));
}

// ============================
// PRESUPUESTOS
// ============================
export async function fetchPresupuestos() {
  const res = await req('GET', 'presupuestos.php');
  return (res.data || res || []).map(i => mapFields(i, true));
}
export async function createPresupuesto(data) {
  const res = await req('POST', 'presupuestos.php', mapFields(data));
  return mapFields(res, true);
}
export async function updatePresupuesto(data) {
  await req('PUT', 'presupuestos.php', mapFields(data));
}
export async function deletePresupuesto(id) {
  return await req('DELETE', `presupuestos.php?id=${id}`);
}
export async function aprobarPresupuesto(id, monto) {
  return await req('PUT', 'presupuestos.php', { id, aprobar: '1', monto });
}

// ============================
// REPUESTOS (INVENTARIO)
// ============================
export async function fetchRepuestos() {
  const res = await req('GET', 'inventario.php');
  return (res.data || res || []).map(i => mapFields(i, true));
}
export async function createRepuesto(data) {
  const res = await req('POST', 'inventario.php', mapFields(data));
  return mapFields(res, true);
}
export async function updateRepuesto(data) {
  await req('PUT', 'inventario.php', mapFields(data));
}
export async function deleteRepuesto(id) {
  return await req('DELETE', `inventario.php?id=${id}`);
}

// ============================
// USUARIOS
// ============================
export async function fetchUsuarios() {
  const res = await req('GET', 'usuarios.php');
  return (res.data || res || []).map(i => mapFields(i, true));
}
export async function createUsuario(data) {
  const res = await req('POST', 'usuarios.php', mapFields(data));
  return mapFields(res, true);
}
export async function updateUsuario(data) {
  await req('PUT', 'usuarios.php', mapFields(data));
}
export async function deleteUsuario(id) {
  return await req('DELETE', `usuarios.php?id=${id}`);
}

// ============================
// BITÁCORA / HISTORIAL / MOVIMIENTOS
// ============================
export async function fetchBitacora() {
  const res = await req('GET', 'reparacion.php?tipo=bitacora');
  return (res.data || res || []).map(i => mapFields(i, true));
}
export async function fetchMovimientosStock() {
  const res = await req('GET', 'reparacion.php?tipo=movimientos');
  return (res.data || res || []).map(i => mapFields(i, true));
}
export async function fetchHistorialEquipos() {
  const res = await req('GET', 'reparacion.php?tipo=historial');
  return (res.data || res || []).map(i => mapFields(i, true));
}
export async function fetchAuditorias() {
  const res = await req('GET', 'auditorias.php');
  return (res.data || res || []).map(i => mapFields(i, true));
}

export async function registrarTareaReparacion(data) {
  return await req('POST', 'reparacion.php', { accion: 'tarea', ...mapFields(data) });
}
export async function usarRepuestoReparacion(data) {
  return await req('POST', 'reparacion.php', { accion: 'repuesto', ...mapFields(data) });
}
export async function finalizarReparacion(data) {
  return await req('POST', 'reparacion.php', { accion: 'finalizar', ...mapFields(data) });
}
export async function depositarEquipo(data) {
  return await req('POST', 'reparacion.php', { accion: 'deposito', ...mapFields(data) });
}
export async function sacarDeDeposito(data) {
  return await req('POST', 'reparacion.php', { accion: 'sacar_deposito', ...mapFields(data) });
}

export async function registrarAuditoria(data) {
  return await req('POST', 'auditorias.php', mapFields(data));
}
export async function agregarHistorial(data) {
  return await req('POST', 'reparacion.php', { accion: 'historial', ...mapFields(data) });
}
export async function registrarMovimientoStock(data) {
  return await req('POST', 'reparacion.php', { accion: 'movimiento_stock', ...mapFields(data) });
}

// ============================
// AUTH
// ============================
export async function apiLogin(email, password) {
  const res = await req('POST', 'login.php', { email, password });
  return res.usuario || null;
}
export async function apiLogout() {
  await req('POST', 'logout.php').catch(() => {});
}
export { req };
